<script setup lang="ts">
import { UIButton } from '@groover-dev/groover-ui'

import type { GrooverPlusSubscribeCtaFragment } from '~/graphql/generated'

type Props = GrooverPlusSubscribeCtaFragment

withDefaults(defineProps<Props>(), {
  text: '',
})

function handleClick() {
  // TODO: Implement the click handler logic when we have Stripe integration ready
  // eslint-disable-next-line no-console
  console.log('GrooverPlusSubscribeCta clicked')
}
</script>

<template>
  <UIButton
    :text
    variant="primary"
    color="accent"
    size="large"
    @click="handleClick"
  />
</template>
